import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { FormCard, ImagePrompt, ConfirmModal, Input } from 'modules/common';
import { noop } from 'core/utilities';

function ImageOnUpsell({
  editedUpsell,
  onUpdateEditedUpsell,
  imageFieldName = 'logo_assigned_image',
  title = 'Add Image',
  subtitle = 'Add an image to your upsell card.',
  imageType = 'LOGO',
}) {
  const [showRemoveImageModal, setShowRemoveImageModal] = useState(false);

  // Get the image data based on the field name
  const imageData = editedUpsell[imageFieldName];
  const imageUri = imageData && imageData.image ? imageData.image.thumbnailUrl : null;
  const imageValue = imageData && imageData.image ? imageData.image.thumbnailUrl : '';

  return (
    <FormCard classNameFooter="bg--catskill-white" title={title} subtitle={subtitle}>
      <ImagePrompt
        imageUri={imageUri}
        name={imageFieldName}
        selectImageAction={onUpdateEditedUpsell}
        imageType={imageType}
        disabled={editedUpsell._isDisabled}
        removeImageAction={() => setShowRemoveImageModal(true)}
        isNested
      />
      <Input hidden value={imageValue} onChange={noop} />
      <ConfirmModal
        show={showRemoveImageModal}
        title="Remove Image"
        buttonText="Remove"
        handleClose={() => setShowRemoveImageModal(false)}
        buttonColor="cancel"
        onSubmit={() => {
          const value = {
            destroy: true,
            imageId: imageData.image.id,
            id: imageData.id,
          };

          onUpdateEditedUpsell({ target: { name: imageFieldName, value } });
          setShowRemoveImageModal(false);
        }}
      >
        Are you sure you want to remove this image from your upsell?
      </ConfirmModal>
    </FormCard>
  );
}

ImageOnUpsell.propTypes = {
  className: PropTypes.string,
  editedUpsell: PropTypes.object.isRequired,
  onUpdateEditedUpsell: PropTypes.func.isRequired,
  imageFieldName: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  imageType: PropTypes.string,
};

export default ImageOnUpsell;
